import { useEffect } from "react";
import { useGoogleTag } from "../../../hooks/useGoogleTag";

export const Loader = ({ handleLoader }: { handleLoader: () => void }) => {
    useGoogleTag('Loader');
    useEffect(() => {
        setTimeout(() => {
            handleLoader();
        }, 8000)
    })
    return (
        <>
            <div className="">
                <div className="flex flex-col items-center justify-center gap-5 lg:-mt-2 pb-10">
                    <h2 className="text-2xl text-center text-stone-700 px-2 lg:text-3xl font-bold">Enregistrement de votre demande</h2>
                    <div className="flex flex-col items-center justify-center mt-4">
                        <div role="status">
                            <svg
                                aria-hidden="true"
                                className="w-24 h-24 text-primaryNewComparateurFibre animate-spin"
                                viewBox="0 0 100 100"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                {/* Cercle de fond très fin */}
                                <circle
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    fill="none"
                                />
                                {/* Arc blanc fin (le petit trait) */}
                                <path
                                    d="M95 50A45 45 0 0 0 50 5"
                                    stroke="white"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    fill="none"
                                />
                            </svg>
                            <span className="sr-only">Chargement...</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
